import { rokidMetisBaseUrl,rokidAgentStoreBaseUrl } from "@rokid/host";
import {
  request,
  type IRequest,
  type IResult,
  type pageData,
} from "@rokid/utils";
import {createThirdAgentParms,editThirdAgentParms,ThirdAgent } from "./thirdAgent"

//创建三方智能体
export const addThirdAgent: IRequest<
  createThirdAgentParms,
  boolean
> = (data) => {
  return request({
    url: `${rokidMetisBaseUrl}/agent/addThirdAgent`,
    method: "post",
    data,
    needToken:true
  }).then((res) => res.data);
};

//查询三方智能体列表
export const  getThirdAgentList: IRequest<
  {
    modelVendor: string; //三方厂商
    name?: string; //关键词
    has_published?: boolean; //是否发布
    pageNum?: number;
    pageSize?: number;
  },
  { list: ThirdAgent[], pageNum: number; pageSize: number; total:number}
> = (data) => {
  return request({
    url: `${rokidMetisBaseUrl}/agent/getThirdAgentList`,
    method: "post",
    data,
    needToken:true
  }).then((res) => {
    return res.data;
  });
};

//修改三方智能体
export const updateThirdAgent: IRequest<
  createThirdAgentParms,
  boolean
> = (data) => {
  return request({
    url: `${rokidMetisBaseUrl}/agent/updateThirdAgent`,
    method: "post",
    data,
    needToken:true
  }).then((res) => {
    //此处成功后，res.data是个空值，所以通过code判断结果
    if (res.code === 1) {
      return true;
    }
    return false;
  });
};

//删除三方智能体
export const deleteThirdAgent: IRequest<
  { modelVendor: string; agentId: string; },
  boolean
> = (data) => {
  return request({
    url: `${rokidMetisBaseUrl}/agent/deleteThirdAgent`,
    method: "post",
    data,
    needToken:true
  }).then((res) => {
    //此处成功后，res.data是个空值，所以通过code判断结果
    if (res.code === 1) {
      return true;
    }
    return false;
  });
};


//三方智能体提审
export const publishThirdAgent: IRequest<
  {
    "botId":string, //agentId，智能体id
    "name":string, //智能体名称
    "description":string, //智能体描述，目前和prompt一样
    "prompt":string, //智能体提示词，目前和description一样
    "versionLog":string,
    "logo":string, //智能体图片
    "needParam":string, //智能体入参类型
    "category": string,
    "categoryName": string,
    "prologue": string, // 开场白
    "suggestedQuestions": string, // 开场白引导问题数组转字符串
    "modelVendor": string, // agent厂商，lingzhu（灵珠agent）coze（扣子agent），bailian（百炼agent）,custom（自定义）
    "suggestedQuestionsShowMode": number; //是否全部展示
   },
  boolean
> = (data) => {
  return request({
    url: `${rokidAgentStoreBaseUrl}/developer/cozePublish`,
    method: "post",
    data,
    needToken:false
  }).then((res) => {
    const {publish_result,check_not_pass,connector_bind_result } = res.data;
    if (publish_result['1024']?.code === 0) {
      return true;
    }
    return false;
  });
};
